module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/verona.e4fbec3ae43d495ac662150586d663bd.jpg";